// extracted by mini-css-extract-plugin
export default {"errorPage":"ErrorPage_errorPage__ozIXZ"};